import LocalizedStrings from 'react-localization';

const enGB = {
    Entry_AccountHold: 'Finance: Account is on hold',
    Entry_Dates: 'Dates',
    Entry_Gender: 'Gender',
    Entry_IncidentsLabel: 'Incidents:',
    Entry_Location: 'Location',
    Entry_MedicalLabel: 'Medical:',
    Entry_NotesLabel: 'Notes:',
    Entry_Private: 'Private',
    Entry_ProfilePicture: 'Profile Picture',
    Entry_ResidentNr: 'Resident Number:',
    Entry_RoomType: 'Room / Type',
    Entry_ViewMoreDetails: 'View More Details',

    Label_Text: 'Text',
    Label_CSV: 'CSV',
    Label_PDF: 'PDF',
    Label_XML: 'XML',
    Label_FixedWidthText: 'Fixed Width Text',
    Label_Html: 'HTML',

    ViewPicker_Label_ActiveView: 'Active View - {0}',
    ViewPicker_Label_SelectView: 'Select View',
    View_Label_MySavedLists: 'My Saved Lists',
    View_Label_MyDynamicLists: 'My Dynamic Lists',
    View_Label_SharedList: 'Shared List',
    View_Label_SharedSavedList: 'Shared Saved List',
    View_Label_SharedDynamicLists: 'Shared Dynamic Lists',
    View_Label_ManageDynamicLists: 'Manage Dynamic Lists',
    View_Label_ManageSavedLists: 'Manage Saved Lists',
    View_Label_NoItems: 'No Items',
    View_Label_ViewFavourited: 'Favourite this view',
    View_Label_ViewIsFavourite: '{0} is favourite',
    View_Label_ViewNotFavourited: 'Remove favourite from this view',
    View_Label_ViewIsUnfavourite: '{0} is unfavourite',
    View_Label_ToggleFavouriteView: '{0} is favourite, press to unfavourite view',
    View_Label_ToggleUnfavouriteView: '{0} is unfavourite, press to favourite view',
    View_Label_OpenList: 'Open list',
    View_Label_CloseList: 'Close list',
    View_Label_AllEntries: 'All Entries',
    View_Label_ActiveEntries: 'Active Entries',

    SaveView_Label_SaveView: 'Save View',
    SaveView_Label_SaveViewAsDynamicList: 'Save View as Dynamic List',
    SaveView_Label_Save: 'Save',
    SaveView_Label_SaveAsNew: 'Save as new',
    SaveView_Label_Name: 'Name',
    SaveView_Label_Folder: 'Folder',
    SaveView_Label_Select: 'Select...',
    SaveView_Message_PleaseEnterAName: 'Please enter a name',
    SaveView_Message_PleaseSelectAFolder: 'Please select a folder',

    Action_Save: 'Save',
    Action_Cancel: 'Cancel',
    Action_Close: 'Close',

    MainDirectory_Label_ActiveTermBooking: 'Active Term Booking',
    MainDirectory_Label_ApplicationStatus: 'Application Status',
    MainDirectory_Label_AppliedForTerm: 'Applied For Term',
    MainDirectory_Label_BookingForTerm: 'Booking For Term',
    MainDirectory_Label_Category: 'Category',
    MainDirectory_Label_Community: 'Community',
    MainDirectory_Label_Gender: 'Gender',
    MainDirectory_Label_NewEntry: 'New Entry',
    MainDirectory_Label_EntryStatus: 'Entry Status',
    MainDirectory_Label_EntryPhoto: 'Entry Photo',
    MainDirectory_Label_Flag: 'Flag',
    MainDirectory_Label_RoomTypes: 'Room Types',
    MainDirectory_Label_SituationResponseFlag: 'Situation Response Flag',
    MainDirectory_Label_UpcomingEvents: 'Upcoming Events',
    MainDirectory_Label_UpcomingGroups: 'Upcoming Groups',

    ViewSearch_Label_Search: 'Search',
    ViewSearch_Label_Loading: 'Loading search results',
    ViewSearch_Label_SearchForView: 'Search for views',
    ViewSearch_Label_ClearSearch: 'Clear Search',
    ViewSearch_Label_NoResultsFound: 'No Results Found',
    ViewSearch_Label_NoSearchResultsFound: 'No search results found for {0}',
    ViewSearch_Label_SearchResultsFound: '{0} search results found for {1}',

    MainDirectory_Label_FurtherOptions: 'Further Options',
    MainDirectory_Label_CheckIn: 'Check In',
    MainDirectory_Label_CheckOut: 'Check Out',
    MainDirectory_Label_AddNote: 'Add Note',
    MainDirectory_Label_RecentActions: 'Recent Actions',
    MainDirectory_Label_NoRecentActions: 'Once you have used actions, your most recent actions will be displayed here.',
    MainDirectory_Label_MoreActions: 'More Actions',

    Action_Status_Loading: 'Loading...',

    TooComplexBar_Label_ContextText: 'List created with Report Generator.',
    TooComplexBar_Label_NoActionText: 'Filters can’t be displayed here.',
    TooComplexBar_Label_ActionText: 'To view and edit filters',
    TooComplexBar_Label_Button: 'click here',

    SituationResponseLabel_Label_Context: 'indicated they are Not Okay.',
    SituationResponseLabel_Label_Entry: 'entry',
    SituationResponseLabel_Label_Entries: 'entries',
};

const enUS = {
    //
};

export const strings = new LocalizedStrings({
    en: {
        ...enGB,
    },
    'en-US': {
        ...enGB,
        ...enUS,
    },
});
